import React from "react";
import SignUpContainer from "components/modules/SignUp/SignUp";

const SignUp = () => {
  return (
    <div>
      <SignUpContainer />
    </div>
  );
};

export default SignUp;
